import * as React from 'react'
import { ServiceLocationsPropertyListCardProps } from './typings'
import {
  useGetServiceLocationListPropAddressBlock,
  useGetServiceLocationListPropValue,
  serviceLocationPropertyCardStyles,
} from './hooks'

import { GridLocationLink } from '@user/components/xGrid'
import { notAvailableValue } from './constants'
import Box from '@mui/material/Box'

export const ServiceLocationsPropertyCard: React.FC<
  ServiceLocationsPropertyListCardProps
> = (props) => {
  const { location, field } = props
  const { cellValue } = useGetServiceLocationListPropValue(location, field)
  const { serviceLocationRowFormatted } =
    useGetServiceLocationListPropAddressBlock(location)
  return (
    <Box sx={serviceLocationPropertyCardStyles.container}>
      <Box sx={serviceLocationPropertyCardStyles.name}>
        {serviceLocationRowFormatted}
      </Box>
      <Box sx={serviceLocationPropertyCardStyles.value}>
        {field === 'externalLocationCode' ? (
          typeof location.externalLinkId === 'string' &&
          typeof location.locationCode === 'string' ? (
            <GridLocationLink
              locationId={location.externalLinkId}
              locationCode={location.locationCode}
              variant="service"
            />
          ) : (
            notAvailableValue
          )
        ) : (
          cellValue
        )}
      </Box>
    </Box>
  )
}
ServiceLocationsPropertyCard.displayName = 'ServiceLocationsPropertyCard'
